export var defaultCountriesAvailability = [
    "se",
    "fi",
    "no",
    "dk",
    "gb",
    "nl",
    "at",
    "pl",
    "lt",
];
//# sourceMappingURL=defaultCountriesAvailability.js.map